import React from "react"

import PCMAdminPatient from "./PCMAdminPatient/PCMAdminPatient";

const PCMAdminComponent = () => <PCMAdminPatient isFromAddPatient />

export default PCMAdminComponent;
